export default "__VITE_ASSET__B4POGsd9__"